import axios from 'axios'

const baseURL = `${process.env.GATSBY_NETLIFY_API_URL}/reviews`
const baseAllURL = `${process.env.GATSBY_NETLIFY_API_URL}/all-reviews`

export const getLastReviews = async () => {
  const { data } = await axios.get(baseAllURL)

  return data
}

export const getReviewsByProduct = async (external_id, page) => {
  const { data } = await axios.get(baseURL, {
    params: {
      page,
      external_id,
    },
  })

  return data
}

export const addReviewToProduct = async (payload) => {
  const { data } = await axios.post(baseURL, payload)

  return data
}
